export default "__VITE_ASSET__xmwXNKij__"